import { Pipe, PipeTransform, inject } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import dayjs, { Dayjs } from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import { DateTimePipe } from './date-time.pipe';

dayjs.extend(relativeTime);

@Pipe({
  name: 'timeAgo',
  pure: false,
})
export class NimmstaTimeAgoPipe implements PipeTransform {
  private translate = inject(TranslateService);
  private datePipe = inject(DateTimePipe);
  private sanitizer = inject(DomSanitizer);

  transform(value?: dayjs.Dayjs | number | Date): SafeHtml {
    if (!value) {
      return this.translate.instant('timeago.never');
    } else {
      let date: Dayjs | undefined;
      if (typeof value === 'number' && value < 10000000000) {
        date = dayjs(value * 1000);
      } else if (typeof value === 'string' && /^\d+$/.test(value)) {
        date = dayjs(Number.parseInt(value, 10));
      } else if (value) {
        date = dayjs(value);
      }
      const tooltip = this.datePipe.transform(value);
      const timeAgo = date?.fromNow() || '';
      return this.sanitizer.bypassSecurityTrustHtml(`
        <span data-bs-toggle="tooltip" data-bs-placement="top" title="${tooltip}">
          ${timeAgo}
        </span>`);
    }
  }
}
